// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons-wdeFi","description":"description-da9qY"};